import auth from '../services/auth';
import redirect from './redirect';
import routes from '../constants/routes';
import routing from '../services/routing';

export const signOut = async () => {
    const res = await auth.signOut();
    if (res.data && res.data.redirect_uri) {
        redirect(res.data);
    } else {
        routing.push(routes.SIGN_IN);
    }
};

export default signOut;
